module.exports = __webpack_public_path__ + "static/media/humidity1.48f540fe.svg";